/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiI18nDto } from './kpi-i18n-dto';


export interface KpiDefinition { 
    _id: string;
    /**
     * Stable, human-meaningful key within the program.
     */
    key: string;
    /**
     * Localized KPI copy keyed by locale. English (en) and German (de) are required by the write DTOs.
     */
    i18n: KpiI18nDto;
    programId: string;
    status: KpiDefinition.StatusEnum;
    ownerUserId: string;
    createdBy: string;
    /**
     * Search and categorization tags for this KPI.
     */
    tags: Array<string>;
    /**
     * Working head — the most recent version.
     */
    latestVersionId?: string;
    /**
     * The version boards serve. Null until first publish.
     */
    publishedVersionId?: string;
    /**
     * True for KPIs living in the reserved shared-library namespace.
     */
    isLibrary: boolean;
}
export namespace KpiDefinition {
    export const StatusEnum = {
        Draft: 'draft',
        Published: 'published',
        Archived: 'archived'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


